var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"c-summary_value"},[_c('td',{staticClass:"c-summary_value__td c-summary_value__td--label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('td',{staticClass:"c-summary_value__td c-summary_value__td--value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }